import React from 'react';

import { cn } from '~/lib/cn';

import { Icon } from '../Icon';

interface ChevronButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  /**
   * Controls the rotation state.
   * - `false`: 0deg (pointing down)
   * - `true`: 180deg (pointing up)
   */
  isOpen: boolean;
  disableHoverEffect?: boolean;
}

export function ChevronButton({
  isOpen,
  disableHoverEffect = false,
  type = 'button',
  ...props
}: ChevronButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'flex size-xl items-center justify-center rounded-full',
        'transition-all duration-300 ease-out',
        !disableHoverEffect &&
          'hover:bg-emphasis-strong active:bg-primary-default',
      )}
      {...props}
    >
      <div
        data-testid="chevron-icon-container"
        className={cn(
          'transition-transform duration-200',
          isOpen && 'rotate-180',
        )}
      >
        <Icon type="chevron-down" size="sm" />
      </div>
    </button>
  );
}

ChevronButton.displayName = 'ChevronButton';
